<template>
  <div class="header_mini_cart">
    <div class="container top_header_mini_cart d-inline-flex align-items-start p-0">
      <linked-wrapper :location="getLocation">
        <img v-if="item.productVariant.immagine && item.productVariant.immagine.length > 0 && item.productVariant.immagine[0].path" class="img-thumbnail" :src="$getFileSource(item.productVariant.immagine[0].path)" :alt="item.name" />
      </linked-wrapper>
      <div class="top_header_mini_cart_info text-start ms-3">
        <linked-wrapper :location="getLocation" :removeDecorations="true"
          ><span class="fw-bold">{{ item.nome }}</span></linked-wrapper
        >
        <br />
        <span>{{ item.qty }}</span
        >x
        <span>{{ $convertCurrency(item.prezzoUnitario) }}</span>
      </div>
      <button
        v-if="item && item._id"
        type="button"
        class="mini-cart-remove-btn ms-auto"
        @click.stop="handleRemove"
        :aria-label="$t('cart.removeItem')"
        :title="$t('cart.removeItem')"
      >
        <font-awesome-icon :icon="['fas', 'trash']" />
      </button>
    </div>
  </div>
</template>
<script>
import LinkedWrapper from "../../atoms/LinkWrapper/LinkWrapper.vue";
import { removeFromCart } from "../../../composables/manageCart";

export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  components: { LinkedWrapper },
  computed: {
    getLocation() {
      return this.$buildProductURL(this.item._prodotto, this.item._prodottoVariante);
    }
  },
  methods: {
    handleRemove() {
      if (!this.item || !this.item._id) {
        return;
      }
      removeFromCart(this.item);
    }
  }
};
</script>
<style scoped="scoped">
.top_header_mini_cart img {
  width: 70px;
  height: 70px;
}
.top_header_mini_cart {
  width: 100%;
}
.mini-cart-remove-btn {
  border: none;
  background: transparent;
  color: #999;
  padding: 4px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s ease;
}
.mini-cart-remove-btn:hover,
.mini-cart-remove-btn:focus-visible {
  color: var(--primary-color);
}
@media screen and (min-width: 1400px) {
  .subtitle-responsive {
    display: none !important;
  }
}
</style>
